// src/lib/patientApi.js

import axios from "axios";
import {
  getPatientAccessToken,
  isJwtExpired,
  patientLogout,
} from "./patientAuth";

const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || "http://localhost:8001";

export const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:8001";

export const api = axios.create({
  baseURL: BACKEND_URL,
  timeout: 30000,
});

api.interceptors.request.use(
  (config) => {
    const token = getPatientAccessToken();

    if (token) {
      if (isJwtExpired(token)) {
        patientLogout({ reason: "session_expired" });
        return Promise.reject(new Error("Session expired"));
      }

      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      patientLogout({ reason: "session_expired" });
    }

    return Promise.reject(error);
  }
);

// export function buildS3ProxyUrl(bucket, key) {
//   if (!bucket || !key) return null;

//   const encodedBucket = encodeURIComponent(bucket);
//   const encodedKey = encodeURIComponent(key);

//   return `${BACKEND_URL}/api/v1/storage/s3/proxy?bucket=${encodedBucket}&key=${encodedKey}`;
// }

export function buildS3ProxyUrl(bucket, key) {
  if (!bucket || !key) return null;
  return `${API_BASE_URL}/api/v1/files/s3-proxy?bucket=${encodeURIComponent(
    bucket
  )}&key=${encodeURIComponent(key)}`;
}

export default api;